import Facebook from "atd-icons/dist/Facebook";
import Instagram from "atd-icons/dist/Instagram";
import Linkedin from "atd-icons/dist/Linkedin";
import Tiktok from "atd-icons/dist/Tiktok";
import Twitter from "atd-icons/dist/Twitter";
import clsx from "clsx";

export default function SocialLinks({ links = [], header = false }) {
  const formattedLinks = getSocialProfiles(links, header);

  if (formattedLinks && formattedLinks?.length > 0) {
    return (
      <ul className={"flex gap-[18px] items-center md:justify-start"}>
        {formattedLinks.map(({ link, icon }, idx) => (
          <li key={idx}>
            <a
              href={link}
              target={"_blank"}
              rel={"noreferrer"}
              aria-label="social-link"
              className={clsx({
                "[&>svg]:duration-200 [&>svg]:opacity-50 hover:[&>svg]:opacity-1": true,
                "[&>svg]:!opacity-100": header,
              })}
            >
              {icon}
            </a>
          </li>
        ))}
      </ul>
    );
  }
}

function getSocialProfiles(links, header = false) {
  let socialLinks = [];
  const size = header ? 20 : 30;

  for (let i = 0; i < links.length; i++) {
    const { profile, url } = links[i];

    switch (profile) {
      case "TikTok":
        socialLinks.push({
          link: url,
          icon: <Tiktok color="#FFF" size={size} />,
        });
        break;
      case "Facebook":
        socialLinks.push({
          link: url,
          icon: <Facebook color="#FFF" size={size} />,
        });
        break;
      case "X (Twitter)":
        socialLinks.push({
          link: url,
          icon: <Twitter color="#FFF" size={size} />,
        });
        break;
      case "Instagram":
        socialLinks.push({
          link: url,
          icon: <Instagram color="#FFF" size={size} />,
        });
        break;
      case "LinkedIn":
        socialLinks.push({
          link: url,
          icon: <Linkedin color="#FFF" size={size} />,
        });
        break;
      default:
        break;
    }
  }
  return socialLinks;
}
